
import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import InvoiceItemInput from '../Input Components/InvoiceItemInput'; // Import InvoiceItem component
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const InvoiceInput = () => {
  const { invoiceId = '' } = useParams();
  const decodedId = invoiceId ? atob(invoiceId) : invoiceId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [invoiceItems, setInvoiceItems] = useState([]); // State to store invoice items
  const [customers, setCustomers] = useState([]); // State to store invoice items
  const [showAddInvoiceItemButton, setShowAddInvoiceItemButton] = useState(false);
  const [newinvoiceId, setInvoiceId] = useState(id);
  const route = 'invoice';

  useEffect(() => {
    if (invoiceId) {
      setIsEditing(true);
      fetchInvoiceDetails();  
    }

    fetchCustomers();
  }, [invoiceId]);

  const fetchInvoiceDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${id}/`, { headers });
      const invoiceDetails = response.data;

      setFormData(invoiceDetails);
      setInvoiceItems(invoiceDetails.invoice_items || []); // Fetch invoice items
    } catch (error) {
      console.error('Error fetching invoice details:', error);
    }
  };

  const fetchCustomers = async () => {
  try {
    const response = await axios.get(`${API_DOMAIN}${API_ROUTES.customer}`, { headers });
    const customers = response.data;

    const customerOptions = customers.map(customer => ({
      value: customer.id,
      label: customer.name,
    }));


    setCustomers(customerOptions);
  } catch (error) {
    console.error('Error fetching customers:', error);
  }
};

 
  const handleAddInvoiceItem = () => {
    setInvoiceItems([...invoiceItems, { item_name: '', quantity: '', unit_price: '' }]);
  };

  const handleFormSubmitSuccess = (response) => {

    setInvoiceId(response.id);
    setShowAddInvoiceItemButton(true);
  };

  const invoiceFields = [
 
    {
      name: 'customer',
      label: 'Customer',
      type: 'select',
      options: customers,
    },
    {
      name: 'issue_date',
      label: 'Issue Date',
      type: 'date',
    },
    {
      name: 'due_date',
      label: 'Due Date',
      type: 'date',
    },


    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
    },
  ];


  return (
    <div>
      <h1>{isEditing ? 'Edit Invoice' : 'Create Invoice'}</h1>
      <FormComponent 
        fields={invoiceFields} 
        initialFormData={formData} 
        route={route} 
        onSubmitSuccess={handleFormSubmitSuccess} 
        onSubmitError={() => {}}
      />
      {showAddInvoiceItemButton && (
        <button onClick={handleAddInvoiceItem}>Add Invoice Item</button>
      )}
      {invoiceItems.map((item, index) => (
        <InvoiceItemInput key={index} item={item} invoiceId={newinvoiceId} />
      ))}

    </div>
  );
};

export default InvoiceInput;
